var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,4.29l-1-1L22,3H10V2l-.29-.71-1-1L8,0H2L1.29.29l-1,1L0,2V20l.29.71,1,1L2,22H22l.71-.29,1-1L24,20V5ZM22,19.59l-.41.41H2.41L2,19.59V2.41L2.41,2H7.59L8,2.41V5H21.59l.41.41V19.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/1787897133/media/icon-folder.e03c3d7a796901cbef169bae758f9852.svg";
export { ForwardRef as ReactComponent };